import { ElementRef } from '@angular/core';
import { Rate, RateMap } from '../../models';
import * as am5 from '@amcharts/amcharts5';
import { createGraph } from './graph-utils';

const styles = {
    spot: am5.color('#FFBF00'),
    contract: am5.color('#EC5A24'),
};

export function render(container: ElementRef, rates: RateMap) {
    if (!container) return;

    createGraph(rates, container, styles);
}
